export default "__VITE_ASSET__5eftQJZ$__"